import React, { useState } from "react";
import styles from "./PrefectureSelect.module.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const PrefectureSelect = ({ onPrefectureSelect, onCitySelect, activePrefecture }) => {
  const [filter, setFilter] = useState({
    city: "",
    prefecture: "",
  });
  const { t } = useTranslation();

  const handleFilterChange = (key, value) => {
    if (key === "prefecture" && value === false) {
      // 都道府県をリセットした場合、都道府県と区市町村をリセット
      setFilter({ city: [], prefecture: "" });
      onPrefectureSelect([]);
      onCitySelect([]);
    } else if (key === "prefecture" && value === filter.prefecture) {
      // 同じ都道府県を選択した場合、何もしない
      setFilter((prev) => ({ ...prev, [key]: value }));
    } else if (key === "prefecture" && value !== filter.prefecture) {
      // 異なる都道府県を選択した場合、都道府県を変更し、区市町村をリセット
      onPrefectureSelect([value]);
      onCitySelect([]);
      setFilter((prev) => ({ ...prev, [key]: value, city: [] }));
    } else {
      // 異なる区市町村を選択した場合、区市町村を変更
      setFilter((prev) => ({ ...prev, [key]: value }));
      if (key === "city") {
        onCitySelect([value]);
      }
    }
  };

  return (
    <div className={styles.PrefectureSelect}>
      <div className={styles.wrapper}>
        <div className={styles.areaPanel}>
          {activePrefecture.map((prefecture, index) => (
            <button
              key={index}
              onClick={() => handleFilterChange("prefecture", prefecture.pref)}
              className={
                filter.prefecture === prefecture.pref ? styles.active : styles.inactive
              }
            >
              {t(prefecture.pref)}
            </button>
          ))}
        </div>
        <div
          className={styles.prefecturePanel}
          style={{ display: filter.prefecture ? "block" : "none" }}
        >
          {activePrefecture.find(element => element.pref === filter.prefecture)?.cities.map((city, index) => (
            <button
              key={index}
              onClick={() => handleFilterChange("city", city.city)}
              className={ filter.city === city.city ? styles.active: styles.default}
            >
              {t(city.city)}
            </button>
          ))}
        </div>
        <div
          style={{ display: filter.prefecture ? "block" : "none" }}
          className={styles.clearButton}
          onClick={() => handleFilterChange("prefecture", false)}
        >
          <FontAwesomeIcon icon={faXmark} />
        </div>
      </div>
    </div>
  );
};

export default PrefectureSelect;
